import script from "./MyProfileUserAccountDeletion.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProfileUserAccountDeletion.vue?vue&type=script&setup=true&lang=ts"

import "./MyProfileUserAccountDeletion.vue?vue&type=style&index=0&id=5a5b7adc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5b7adc"]])

export default __exports__